<template>
  <div class="service-book-dashboard px-0">
    <h4 v-if="!isEmbedded" class="atlhr-dashboard-title mt-10 px-0 mb-4">
      Service Book Management<span><a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> /
        Service Book</span>
    </h4>
    <div class="card-custom gutter-b">
      <!-- <div class="card-header border-0 pt-6 pb-2 d-flex justify-content-between align-items-center bg-white">
        <h3 class="card-title align-items-start flex-column mb-0">
          <span class="card-label font-weight-bolder text-dark">Service Records (Admin)</span>
          <span class="text-muted mt-1 font-weight-bold font-size-sm">Detailed employee service history</span>
        </h3>
        <div class="card-toolbar">
          <b-dropdown
            variant="primary"
            toggle-class="border rounded bg-light py-1 px-2"
            class="ml-2"
            right
            :disabled="downloadingAll"
          >
            <template #button-content>
              <i class="far fa-file-archive px-1" aria-hidden="true" style="font-size:16px;"></i>
              {{ downloadingAll ? 'Downloading...' : 'Download All' }}
            </template>
            <b-dropdown-item @click="handleDownloadAll('both')">Mixed (Bangla &amp; English)</b-dropdown-item>
            <b-dropdown-item @click="handleDownloadAll('bn')">Bangla Only</b-dropdown-item>
            <b-dropdown-item @click="handleDownloadAll('en')">English Only</b-dropdown-item>
          </b-dropdown>
        </div>
      </div> -->

      <!-- <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper mx-3">
        <div class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
          <ul class="nav nav-pills leave-attendance-dashboard-tab">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'identification' }"
                @click="activeTab = 'identification'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Worker Identification</span>
                <span class="nav-subtext bn-text">শ্রমিকের পরিচয়ানুমূলক তথ্য</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'employment' }"
                @click="activeTab = 'employment'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Employer & Employment</span>
                <span class="nav-subtext bn-text">মালিক ও চাকরির তথ্য</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'service-wages' }"
                @click="activeTab = 'service-wages'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Service, Wages & Allowance</span>
                <span class="nav-subtext bn-text">মজুরি ও ভাতা রেকর্ড</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'leave' }"
                @click="activeTab = 'leave'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Leave Record</span>
                <span class="nav-subtext bn-text">ছুটির রেকর্ড</span>
              </a>
            </li>
            <li class="nav-item" v-if="!hideBehavioral">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'behavioral' }"
                @click="activeTab = 'behavioral'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Behavioral Record</span>
                <span class="nav-subtext bn-text">আচরণিক রেকর্ড</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div v-if="activeTab === 'identification'">
            <service-book-worker-identification-document
              ref="workerIdentification"
              :is-embedded="isEmbedded"
            ></service-book-worker-identification-document>
          </div>
          <div v-else-if="activeTab === 'employment'">
            <service-book-employer-and-employment-details
              ref="employmentDetails"
              :is-embedded="isEmbedded"
            ></service-book-employer-and-employment-details>
          </div>
          <div v-else-if="activeTab === 'service-wages'">
            <service-book-service-wages-and-allowance-record
              ref="serviceWages"
            ></service-book-service-wages-and-allowance-record>
          </div>
          <div v-else-if="activeTab === 'leave'">
            <service-book-service-leave-record
              ref="leaveRecord"
            ></service-book-service-leave-record>
          </div>
          <div v-if="!hideBehavioral && activeTab === 'behavioral'">
            <service-book-service-behavioral-record
              ref="behavioralRecord"
            ></service-book-service-behavioral-record>
          </div>
        </div>
      </div> -->

        <div class="service-book-tab-title row no-gutters py-2 mb-3">
            <div class="col-md-8 col-sm-12 d-flex align-items-center text-start" >
                <h3 class="card-title align-items-start flex-column mb-0">
                    <span class="card-label font-weight-bolder text-dark">My Service Records</span>
                    <span class="text-muted mt-1 font-weight-bold font-size-sm">Your detailed service history</span>
                </h3>
            </div>
            <div class="col-sm-4 col-sm-4 text-right px-3 d-flex align-items-center justify-content-end ">
                <b-dropdown variant="primary" toggle-class="border rounded bg-light py-1 px-2" class="ml-2" right :disabled="downloadingBooklet">
                    <template #button-content>
                        <i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;"></i>
                        {{ downloadingBooklet ? 'Downloading...' : 'Download Booklet' }}
                    </template>
                    <!-- <b-dropdown-item @click="handleDownloadBooklet('both')">Mixed (Bangla &amp; English)</b-dropdown-item> -->
                    <b-dropdown-item @click="handleDownloadBooklet('bn')">Bangla Only</b-dropdown-item>
                    <b-dropdown-item @click="handleDownloadBooklet('en')">English Only</b-dropdown-item>
                </b-dropdown>
                <b-dropdown variant="primary" toggle-class="border rounded bg-light py-1 px-2" class="ml-2" right :disabled="downloadingAll">
                    <template #button-content>
                        <i class="far fa-file-archive px-1" aria-hidden="true" style="font-size:16px;"></i>
                        {{ downloadingAll ? 'Downloading...' : 'Download All' }}
                    </template>
                    <b-dropdown-item @click="handleDownloadAll('both')">Mixed (Bangla &amp; English)</b-dropdown-item>
                    <b-dropdown-item @click="handleDownloadAll('bn')">Bangla Only</b-dropdown-item>
                    <b-dropdown-item @click="handleDownloadAll('en')">English Only</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper">
            <b-tabs v-model="tabIndex" pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">

                <template >
                    <b-tab lazy v-if="$acl && $acl['admin-service-book/worker-identification'] >= 1">
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Worker Identification</span>
                            <span class="nav-subtext bn-text">শ্রমিকের সনাক্তকরনের তথ্য</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-worker-identification-document ref="workerIdentification" :is-embedded="isEmbedded"></service-book-worker-identification-document>
                        </div>
                    </b-tab>
                    <b-tab lazy v-if="$acl && $acl['admin-service-book/employment-details'] >= 1">
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Employment details</span>
                            <span class="nav-subtext bn-text">চাকরির তথ্য</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-employer-and-employment-details ref="employmentDetails" :is-embedded="isEmbedded"></service-book-employer-and-employment-details>
                        </div>
                    </b-tab>
                    <b-tab lazy v-if="$acl && $acl['admin-service-book/wages-records'] >= 1">
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Service, Wages and Allowance</span>
                            <span class="nav-subtext bn-text">সার্ভিস, মজুরি এবং ভাতা</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-service-wages-and-allowance-record ref="serviceWages" ></service-book-service-wages-and-allowance-record>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="$acl && $acl['admin-service-book/leave-records'] >= 1">
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Leave Record</span>
                            <span class="nav-subtext bn-text">ছুটির রেকর্ড</span>
                        </template>
                        <div class="tab-item-wrapper">
                           <service-book-service-leave-record ref="leaveRecord"></service-book-service-leave-record>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="!hideBehavioral && $acl && $acl['admin-service-book/behavioral-records'] >= 1">
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Behavioral Record</span>
                            <span class="nav-subtext bn-text">আচরণের রেকর্ড</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-service-behavioral-record ref="behavioralRecord" ></service-book-service-behavioral-record>
                        </div>
                    </b-tab>


                </template>

            </b-tabs>

        </div>
    </div>

    <div class="d-flex justify-content-center mt-4 mb-5" v-if="hasViewPermission">
      <b-dropdown
        v-if="hasWritePermission"
        variant="primary"
        toggle-class="border rounded bg-light py-1 px-2"
        class="ml-2"
        right
        :disabled="cooldowns[activeTab] && cooldowns[activeTab].email > 0"
      >
        <template #button-content>
          <i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i>
          {{
            cooldowns[activeTab] && cooldowns[activeTab].email > 0
              ? "Email (" + formatTime(cooldowns[activeTab].email) + ")"
              : "Email"
          }}
        </template>
        <b-dropdown-item @click="handleEmail('both')">Bangla & English</b-dropdown-item>
        <b-dropdown-item @click="handleEmail('bn')">Bangla Only</b-dropdown-item>
        <b-dropdown-item @click="handleEmail('en')">English Only</b-dropdown-item>
      </b-dropdown>

      <b-dropdown
        variant="primary"
        toggle-class="border rounded bg-light py-1 px-2"
        class="ml-2"
        right
        :disabled="cooldowns[activeTab] && cooldowns[activeTab].download > 0"
      >
        <template #button-content>
          <i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;"></i>
          {{
            cooldowns[activeTab] && cooldowns[activeTab].download > 0
              ? "Download PDF (" + formatTime(cooldowns[activeTab].download) + ")"
              : "Download PDF"
          }}
        </template>
        <b-dropdown-item @click="handleDownload('both')">Bangla & English</b-dropdown-item>
        <b-dropdown-item @click="handleDownload('bn')">Bangla Only</b-dropdown-item>
        <b-dropdown-item @click="handleDownload('en')">English Only</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEmbedded: { type: Boolean, default: false },
    hideBehavioral: { type: Boolean, default: false },
    employee_id: { type: [Number, String], default: null }
  },
  created() {
    const tabs = ["identification", "employment", "service-wages", "leave", "behavioral"];
    const mapping = {
      identification: "admin-service-book/worker-identification",
      employment: "admin-service-book/employment-details",
      "service-wages": "admin-service-book/wages-records",
      leave: "admin-service-book/leave-records",
      behavioral: "admin-service-book/behavioral-records",
    };
    let firstTab = null;
    for (let tab of tabs) {
      if (tab === "behavioral" && this.hideBehavioral) continue;
      const resource = mapping[tab];
      if (this.$acl && this.$acl[resource] >= 1) {
        firstTab = tab;
        break;
      }
    }
    if (firstTab) {
      this.activeTab = firstTab;
      const idx = this.visibleTabs.indexOf(firstTab);
      if (idx !== -1) {
        this.tabIndex = idx;
      }
    }
  },
  data() {
    return {
      apiPrefix: "/admin-service-book",
      activeTab: "identification",
      tabIndex: 0,
      downloadingAll: false,
      downloadingBooklet: false,
      cooldowns: {
        identification: { download: 0, email: 0 },
        employment: { download: 0, email: 0 },
        "service-wages": { download: 0, email: 0 },
        leave: { download: 0, email: 0 },
        behavioral: { download: 0, email: 0 },
      },
      masterTimer: null,
    };
  },
  computed: {
    storageKey() { return `service_book_cooldowns_${this.employee_id}`; },
    visibleTabs() {
      const tabs = [];
      if (this.$acl && this.$acl["admin-service-book/worker-identification"] >= 1) {
        tabs.push("identification");
      }
      if (this.$acl && this.$acl["admin-service-book/employment-details"] >= 1) {
        tabs.push("employment");
      }
      if (this.$acl && this.$acl["admin-service-book/wages-records"] >= 1) {
        tabs.push("service-wages");
      }
      if (this.$acl && this.$acl["admin-service-book/leave-records"] >= 1) {
        tabs.push("leave");
      }
      if (!this.hideBehavioral && this.$acl && this.$acl["admin-service-book/behavioral-records"] >= 1) {
        tabs.push("behavioral");
      }
      return tabs;
    },
    hasViewPermission() {
      const mapping = {
        identification: "admin-service-book/worker-identification",
        employment: "admin-service-book/employment-details",
        "service-wages": "admin-service-book/wages-records",
        leave: "admin-service-book/leave-records",
        behavioral: "admin-service-book/behavioral-records",
      };
      const resource = mapping[this.activeTab];
      return resource && this.$acl && this.$acl[resource] >= 1;
    },
    hasWritePermission() {
      const mapping = {
        identification: "admin-service-book/worker-identification",
        employment: "admin-service-book/employment-details",
        "service-wages": "admin-service-book/wages-records",
        leave: "admin-service-book/leave-records",
        behavioral: "admin-service-book/behavioral-records",
      };
      const resource = mapping[this.activeTab];
      return resource && this.$acl && this.$acl[resource] == 2;
    },
    canDownloadAll() {
      const keys = [
        "admin-service-book/worker-identification",
        "admin-service-book/employment-details",
        "admin-service-book/wages-records",
        "admin-service-book/leave-records",
        "admin-service-book/behavioral-records",
      ];
      return keys.some(key => this.$acl && this.$acl[key] == 2);
    }
  },
  watch: {
    tabIndex(val) {
      if (this.visibleTabs && this.visibleTabs[val]) {
        this.activeTab = this.visibleTabs[val];
      }
    }
  },
  methods: {
    handleDownload(lang = "both") {
      if (this.activeTab === "identification") {
        if (this.$refs.workerIdentification) this.$refs.workerIdentification.downloadPdf(lang);
      } else if (this.activeTab === "employment") {
        axios.post(this.$api_url + this.apiPrefix + "/download-employment-details-pdf", { lang: lang }, { responseType: "blob" })
          .then((response) => { this.global_download_file_content(response); })
          .catch((error) => { console.error("Error downloading PDF:", error); });
      } else if (this.activeTab === "service-wages") {
        if (this.$refs.serviceWages) this.$refs.serviceWages.downloadPdf(lang);
      } else if (this.activeTab === "leave") {
        if (this.$refs.leaveRecord) this.$refs.leaveRecord.downloadPdf(lang);
      } else if (this.activeTab === "behavioral") {
        if (this.$refs.behavioralRecord) this.$refs.behavioralRecord.downloadPdf(lang);
      }
    },
    handleDownloadAll(lang) {
      if (this.downloadingAll) return;
      this.downloadingAll = true;
      var self = this;
      axios.post(this.$api_url + this.apiPrefix + "/download-all-pdf", { lang: lang }, { responseType: "blob" })
        .then(function (response) { self.global_download_file_content(response); })
        .finally(function () { self.downloadingAll = false; });
    },
    handleDownloadBooklet(lang) {
      if (this.downloadingBooklet) return;
      this.downloadingBooklet = true;
      var self = this;
      axios.post(this.$api_url + this.apiPrefix + "/download-booklet-pdf", { lang: lang }, { responseType: "blob" })
        .then(function (response) { self.global_download_file_content(response); })
        .catch(function (error) { console.error("Error downloading Booklet PDF:", error); })
        .finally(function () { self.downloadingBooklet = false; });
    },
    handleEmail(lang = "both") {
      if (!this.hasWritePermission) {
        this.$bvToast.toast("You are not authorized to send email.", { title: "Error", variant: "danger", solid: true });
        return;
      }

      let endpoint = "";
      if (this.activeTab === "identification") endpoint = this.apiPrefix + "/email-worker-identification-pdf";
      else if (this.activeTab === "employment") endpoint = this.apiPrefix + "/email-employment-details-pdf";
      else if (this.activeTab === "service-wages") endpoint = this.apiPrefix + "/email-wages-records-pdf";
      else if (this.activeTab === "leave") endpoint = this.apiPrefix + "/email-leave-records-pdf";
      else if (this.activeTab === "behavioral") endpoint = this.apiPrefix + "/email-behavioral-records-pdf";

      if (!endpoint) return;

      this.$bvModal.msgBoxConfirm("Are you sure you want to email this record to the employee?", {
        title: "Send PDF via Email", okTitle: "Yes, Send", okVariant: "primary", centered: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        axios.post(this.$api_url + endpoint, { lang: lang }).then((response) => {
          if (response.data.success) {
            this.$bvToast.toast(response.data.message, { title: "Success", variant: "success", solid: true });
          }
        });
      });
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    },
  }
};
</script>

<style scoped>
.service-book-dashboard { background-color: #f4f7f6; padding: 0; }
.leave-attendance-dashboard-tab .nav-link {
  display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
  padding: 1.5rem 0.5rem 2rem 0.5rem !important; min-height: 120px; border-radius: 8px 8px 0 0 !important; transition: all 0.2s ease-in-out;
}
.leave-attendance-dashboard-tab .nav-link.active { background-color: rgba(54, 153, 255, 0.15) !important; color: #3699ff !important; }
.leave-attendance-dashboard-tab .nav-link.active::after { display: none !important; }
.nav-text { font-size: 0.95rem; line-height: 1.2; }
.nav-subtext { font-size: 0.8rem; font-weight: 500; margin-top: 6px; }
.bn-text { font-family: "notosansbengali", sans-serif; }
.leave-attendance-dashboard-tab .nav-item { width: 19% !important; margin: 0 2px 0 0 !important; }
</style>
